<div class="modal__header">
  <span class="title">{{title}}</span>
  <div *ngIf="!isHasExpiriesPassword" class="modal-close color-gray-dark" (click)="activeModal.close();"></div>
  <div *ngIf="isHasExpiriesPassword" class="modal-close color-gray-dark" (click)="activeModal.dismiss()"></div>
</div>
<div class="modal__body">
  <span>{{content}}</span>
</div>
<div class="modal__footer">
  <div class="modal__footer-action">
    <button class="button" type="button" (click)="activeModal.dismiss()">Изменить пароль</button>
  </div>
  <div class="modal__footer-action" *ngIf="!isHasExpiriesPassword">
    <a class="link link--dotted-blue-dark" (click)="activeModal.close();"> Не сейчас </a>
  </div>
</div>
